import SurveySchema from '@ax2/common/model/schemas/SurveySchema';
import {
  downloadXlsxResults,
  downloadXlsxAnswers,
} from 'rest/makeSurveyClient';
import FileSaver from 'file-saver';

export const exportResultsAsXlsx = async (
  survey: SurveySchema
): Promise<void> => {
  downloadXlsxResults(survey.id).then(blob =>
    FileSaver.saveAs(blob, `${survey.title} Chart Data.xlsx`)
  );
};

export const exportAnswersAsXlsx = async (
  survey: SurveySchema
): Promise<void> => {
  downloadXlsxAnswers(survey.id).then(blob =>
    FileSaver.saveAs(blob, `${survey.title} Raw Question Data.xlsx`)
  );
};
